"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MultiValueLabel = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _typeaheadMultiSelect = require("./typeaheadMultiSelect.style");
var _DynamicOptions = _interopRequireDefault(require("./DynamicOptions"));
var _StaticOptions = _interopRequireDefault(require("./StaticOptions"));
var _reactSelect = require("react-select");
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const MultiValueLabel = props => {
  return (0, _jsxRuntime.jsx)(_reactSelect.components.MultiValueLabel, (0, _extends2["default"])({}, props, {
    children: props.data[props.renderValue]
  }));
};
exports.MultiValueLabel = MultiValueLabel;
const TypeaheadMultiSelect = props => {
  const {
      className = 'typeaheadMultiSelect',
      suggestType = 'dynamic'
    } = props,
    rest = __rest(props, ["className", "suggestType"]);
  return (0, _jsxRuntime.jsx)(_typeaheadMultiSelect.Components.Wrapper, (0, _extends2["default"])({
    className: className
  }, {
    children: suggestType === 'dynamic' ? (0, _jsxRuntime.jsx)(_DynamicOptions["default"], (0, _extends2["default"])({}, rest)) : (0, _jsxRuntime.jsx)(_StaticOptions["default"], (0, _extends2["default"])({}, rest))
  }));
};
var _default = exports["default"] = TypeaheadMultiSelect;